import { EpimsBaseEntityDto } from './epim-base.dto';

export class CorrespondenceTeamDto extends EpimsBaseEntityDto {
  CorrespondenceTeamName: string;
  SubscriptionUserId: string;
  Email: string;
  Version: number;
}
